import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { PermissionHelper } from '../shared/permissions/permissions';
import { Configuration } from '../shared/services/configuration';
import { HttpClientCustom } from '../shared/services/http.client';
import { ToasterComponent } from '../toasterComponent/toasterComponent';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'underscore';

@Component({
    selector: 'tenant-create',
    templateUrl: './createTenant.html'
})
export class CreateTenantComponent implements OnInit {
    public _baseUrl: any;
    public lang: any = [];
    public modules: any = [];
    public buttonDisabled: any = false;
    public emailExist: any;
    public tenantBaseUrlExist: any;
    public tenantBaseUrl: any;
    public urlExt: string = '.entomo.co';
    public beforeAppending: any;
    public selectedApp: any;
    public itemLangList=[];
    public selectedLangItems=[];
    public langSettings = {};
    public createNewTenantData: any = {
        orgName: null,
        shortName: null,
        appName: null,
        baseUrl: null,
        firstName: null,
        lastName: null,
        displayName: null,
        email: null,
        userName: null,
        languageIds:[],
        fireBaseServerKey: null,
        timeZone: 'GMT+05:30'
    };

    /* public apps = [
        { name: 'Dev skylark', value: 'DEV_SKYLARK' }]; */

    public apps:any;

    constructor(
        public router: Router,
        public _per: PermissionHelper,
        public _global: Configuration,
        public http: HttpClientCustom,
        public translate:TranslateService,
        public _toaster: ToasterComponent, vcr: ViewContainerRef, public _location: Location) {
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
        this.getAllApps();
    }

    public getAllApps(){
        let self = this;
        let url = self._baseUrl + 'v1/superAdmin/mobAppManagement/getAllMobileApp';
        self.http.post(url,{ page: 0, pageSize: 100}).subscribe((result) => {
            self.apps = result.content;
        }, (error) => {
            console.log('Error:', error);
        })
    }

    public ngOnInit() {
        this.getLanguage();
        this.loadTenantModules();
        this.langSettings={text: 'Select Language',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        classes: '',
        primaryKey: 'id',
        labelKey: 'name',
        //badgeShowLimit: 5
    }
    }

    public createNewTenant() {
        let that = this;
        that.buttonDisabled = true;
        that.populateSelectedModules();
        that.addLanguage();
        if(this.selectedApp){
            this.apps.forEach(app => {
                if (this.selectedApp === app.id) {
                    this.createNewTenantData.appName = app.mobileAppKey;
                    this.createNewTenantData.fireBaseServerKey = app.fireBaseKey;
                }
            });
        }
        if (that.validateNewTenant() && that.validateSelectedModules()) {
            that.createNewTenantData.baseUrl= that.beforeAppending +that.urlExt;
            let url = that._baseUrl + 'v1/superAdmin/tenant/createTenant';
            that.http.post(url, that.createNewTenantData).subscribe((result) => {
                this.translate.get('tenantCreated').subscribe((msg)=>{
                    this._toaster.showSuccess(msg);
                });
                that.buttonDisabled = false;
                setTimeout(()=>{that.goBack();},500)
            }, (error: any) => {            
                for (var i = 0; i < error.error.length; i++) {
                  if(error.error[i].defaultMessage == 'SHOULD_NOT_EMPTY') {
                    this.translate.get('mandNotEmpty').subscribe((msg)=>{
                        this._toaster.showError(msg);
                    });
                  } else if(error.error[i].defaultMessage == 'BASE_URL_NOT_AVAILABLE') {
                    this.translate.get('baseUrlNotAvailable').subscribe((msg)=>{
                        this._toaster.showError(msg);
                    });
                  } else if(error.error[i].defaultMessage == 'EMAIL_OR_USERNAME_NOT_EXIST') {
                    this.translate.get('emailOrUserDifferent').subscribe((msg)=>{
                        this._toaster.showError(msg);
                    });
                  }
                  that.buttonDisabled = false;
                //   break;
                }
            })
        }
    }

    public populateSelectedModules() {
        this.createNewTenantData.selectedModules = [];
        let mod: any;
        for (mod of this.modules) {
            if (mod.assigned) {
                this.createNewTenantData.selectedModules.push(mod.operation);
            }
        }
    }

    public validateSelectedModules(): boolean {
        if (this.createNewTenantData.selectedModules.length === 0) {
            this.translate.get('selectOneModule').subscribe((msg)=>{
                this._toaster.showError(msg);
            });
            return false;
        } else {
            return true;
        }
    }

    public validateNewTenant() {
        let that = this;
        if(!that.createNewTenantData.orgName){
            this.translate.get('pleaseEnterTenantName').subscribe((msg)=>{
                this._toaster.showError(msg);
            });
            that.buttonDisabled = false;
            return false;
           

        }
        if(!that.createNewTenantData.shortName){
            this.translate.get('pleaseEnterTenantShortName').subscribe((msg)=>{
                this._toaster.showError(msg);
            });
            that.buttonDisabled = false;
            return false;

        }
        if(!that.createNewTenantData.appName){
            this.translate.get('pleaseSelectAppName').subscribe((msg)=>{
                this._toaster.showError(msg);
            });
            that.buttonDisabled = false;
            return false;

        }
        if(!that.beforeAppending){
            this.translate.get('pleaseEnterBaseUrl').subscribe((msg)=>{
                this._toaster.showError(msg);
            });
            that.buttonDisabled = false;
            return false;
             
        }
       
        if(!that.createNewTenantData.displayName){
            this.translate.get('pleaseEnterDisplayName').subscribe((msg)=>{
                this._toaster.showError(msg);
            });
            that.buttonDisabled = false;
            return false;
            

        }
        if(!that.createNewTenantData.userName){
            this.translate.get('pleaseEnterUserName').subscribe((msg)=>{
                this._toaster.showError(msg);
            });
            that.buttonDisabled = false;
            return false;
             

        }
        if(!that.createNewTenantData.email){
            this.translate.get('pleaseEnterEmail').subscribe((msg)=>{
                this._toaster.showError(msg);
            });
            that.buttonDisabled = false;
            return false;
            

        }
        if (!that.createNewTenantData.timeZone) {
            this.translate.get('selectTimeZone').subscribe((msg)=>{
                this._toaster.showError(msg);
            });
            that.buttonDisabled = false;
            return false;
           
        }
        if (that.createNewTenantData.languageIds.length==0) {
            this.translate.get('selectLanguage').subscribe((msg)=>{
                this._toaster.showError(msg);
            });
            that.buttonDisabled = false;
            return false;
        }

        return true;
    }

    public loadTenantModules() {
        let that = this;
        let url = that._baseUrl + 'v1/superAdmin/tenant/loadTenantModules';
        that.http.get(url).subscribe((result) => {
            that.modules = result;
        }, (error) => {
            that.modules = [];
        });
    }

  public  omit_special_char(event)
    {
       var k;
       k = event.charCode;  //         k = event.keyCode;  (Both can be used)
       return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || k == 45 || (k >= 48 && k <= 57));
    }
    public getLanguage() {
        let that = this;
        let url = that._baseUrl + 'v1/hub/sys/getAllLang';
        that.http.get(url).subscribe((result) => {
            that.lang = result;
            that.itemLangList=that.lang;
            _.each(this.lang,function(key,value){
              if(key.name == 'ENGLISH'){
                   that.createNewTenantData.languageId = key.id;
              }
            });

        }, (error) => {
            that.lang = [];
            console.log(error);
        });
    }
    public goBack() {
        this._location.back();
    }
    public copyToUsername(e) {
        this.createNewTenantData.userName = e;
    }
    public onBlurEmailExist(userName,email){
      let self = this;
      let url = self._baseUrl +"v1/superAdmin/tenant/isUsernameAvailable/userName/"+userName+"/email/"+email;
      self.http.get(url).subscribe((result) => {
        self.emailExist = result;
        if(self.emailExist){
          self.createNewTenantData.email=null
          self.translate.get('emailExist').subscribe((msg)=>{
            self._toaster.showError(msg);
        });
        }
      }, (error => {
        self.emailExist;
        console.log(error);
      })
    )

    }
    public onBlurTenantBaseUrl(tenantBaseUrl){
      let self = this;
      let tenantKpiUrl = tenantBaseUrl+ '.kpisoft.com';

      let url = self._baseUrl +"v1/superAdmin/tenant/tenantBaseUrlExist?tenantBaseUrl="+tenantKpiUrl;
      self.http.get(url).subscribe((result) => {
        self.tenantBaseUrlExist = result;
        if(self.tenantBaseUrlExist){
            self.createNewTenantData.baseUrl=null
            self.translate.get('baseUrlExist').subscribe((msg)=>{
                self._toaster.showError(msg);
            });
        }
      }, (error => {
        self.tenantBaseUrlExist;
        console.log(error);
      })
    )

    }

    public addLanguage(){
        for(let i=0;i<this.selectedLangItems.length;i++){
            this.createNewTenantData.languageIds.push(this.selectedLangItems[i].id);
        }
       
    }
}



// WEBPACK FOOTER //
// ./src/app/superAdmin/createTenant.ts